// extracted by mini-css-extract-plugin
module.exports = {"THEME_NAME":"\"fixtercore\"","cta":"EmailCta_cta__33f_Y"};